import { fetchAPI } from '@/lib/api'

export function sendConsultService(email, tel) {
  return fetchAPI({
    method: 'post',
    path: '/consult_services',
    data: { email, tel },
  })
}
